import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  { path: 'home2', redirectTo: 'installedbase', pathMatch: 'full' },
  { path: 'home', loadChildren: () => import('./home/home.module').then(m => m.HomePageModule) },
  { path: 'details/:id', loadChildren: () => import('./pages/todo-details/todo-details.module').then(m => m.TodoDetailsPageModule) },
  { path: 'details', loadChildren: () => import('./pages/todo-details/todo-details.module').then(m => m.TodoDetailsPageModule) },
  {
    path: 'machines',
    loadChildren: () => import('./pages/machines/machines.module').then( m => m.MachinesPageModule)
  },
  {
    path: '',
    loadChildren: () => import('./pages/installedbase/installedbase.module').then( m => m.InstalledbasePageModule)
  },
  {
    path: 'installedbasedetails',
    loadChildren: () => import('./pages/installedbasedetails/installedbasedetails.module').then( m => m.InstalledbasedetailsPageModule)
  },
  {
    path: 'installedbaseadd',
    loadChildren: () => import('./pages/installedbaseadd/installedbaseadd.module').then( m => m.InstalledbaseaddPageModule)
  },
  {
    path: 'partdetails',
    loadChildren: () => import('./pages/partdetails/partdetails.module').then( m => m.PartdetailsPageModule)
  }


];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
